/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react';
import type { SVGProps } from 'react';
/**
 * @internal
 */
const SvgAttention = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={22} fill="none" {...props}>
    <circle cx={10} cy={12} r={10} fill="#FF9431" />
    <path
      fill="#fff"
      d="M8.893 13.824 8.46 5.4h2.664l-.45 8.424zm.9 4.302q-.63 0-1.044-.414a1.35 1.35 0 0 1-.414-.99q0-.576.414-.972.414-.414 1.044-.414t1.026.414q.396.396.396.972t-.396.99-1.026.414"
    />
  </svg>
);
export default SvgAttention;
